import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import config from '../../../../config';
import { getAuthToken } from '../../../utils/auth';

const useArticleStats = () => {
  const [articles, setArticles] = useState([]);

  const accessToken = getAuthToken();
  const publisherId = useSelector((state) => state.user.publisher?.id);
  // const publisherId = 65;

  useEffect(() => {
    if (publisherId) {
      (async () => {
        // const payload = {
        //   urlFilter: "",
        // };
        const payload = {
          urlFilter: '',
          monetizeType: 'paywall',
        };

        const response = await fetch(
          `${config.ApiBaseUrl}/publisher/${publisherId}/articles/1/10`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify(payload),
          }
        );
        const json = await response.json();

        const { data, message, success } = json;

        if (!success)
          throw new Error(
            message ?? 'Something went wrong. failed to process request'
          );

        const { items } = data;
        const retrievedArticles = items.map((item) => ({
          title: item.title,
          visits: item.articleStatistics.visits,
          unlocked: item.articleStatistics.unlocks,
          paid: item.articleStatistics.paid,
          id: item.id,
        }));

        setArticles(retrievedArticles);
      })();
    }
  }, [publisherId]);

  return articles;
};

export default useArticleStats;
